import { AxiosPost, AxiosPut, AxiosGet } from "../../helpers/microserviceAPIs"

import { assessmentsApiUrl } from "../../config/microservicesUrls"

export async function assessmentsApiListPost(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(jwt, `${api_url}/Assessment/list`, payload)
  if (res === null) {
    throw new Error(`Unable to list assessments`)
  }
  return res
}

export async function assessmentsApiListMiniPost(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(jwt, `${api_url}/Assessment/list/mini`, payload)
  if (res === null) {
    throw new Error(`Unable to get mini list of assessments`)
  }
  return res
}

export async function assessmentsApiGet(jwt, assessmentId) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosGet(jwt, `${api_url}/Assessment/${assessmentId}`)
  if (res === null) {
    throw new Error(`Unable to retrieve assessment profile`)
  }
  return res
}

export async function assessmentsApiQuestionsGet(jwt, assessmentId) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosGet(
    jwt,
    `${api_url}/Assessment/${assessmentId}/Questions`
  )
  if (res === null) {
    throw new Error(`Unable to retrieve assessment questions`)
  }
  return res
}

export async function assessmentsApiCreatePost(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(jwt, `${api_url}/Assessment`, payload)
  if (res === null) {
    throw new Error(`Unable to create new assessment`)
  }
  return res
}

export async function assessmentsApiUpdatePut(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPut(jwt, `${api_url}/Assessment`, payload)
  if (res === null) {
    throw new Error(`Unable to update assessment`)
  }
  return res
}

export async function assessmentsApiDelete(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(jwt, `${api_url}/Assessment/delete`, payload)
  if (res === null) {
    throw new Error(`Unable to delete assessment`)
  }
  return res
}

//Logs a completed assessment
export async function assessmentsApiCompletePost(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(jwt, `${api_url}/Assessment/complete`, payload)
  if (res === null) {
    throw new Error(`Unable to submit a completed assessment`)
  }
  return res
}

//Stage an update to a completed assessment
export async function assessmentsApiStageCompletedUpdatePost(
  jwt,
  completedAssessmentID,
  payload
) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(
    jwt,
    `${api_url}/Assessment/complete/stage/${completedAssessmentID}`,
    payload
  )
  if (res === null) {
    throw new Error(`Unable to stage an update to a completed assessment`)
  }
  return res
}

//Update a completed assessment
export async function assessmentsApiUpdateCompletedPost(
  jwt,
  completedAssessmentID,
  payload
) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(
    jwt,
    `${api_url}/Assessment/complete/${completedAssessmentID}`,
    payload
  )
  if (res === null) {
    throw new Error(`Unable to update a completed assessment`)
  }
  return res
}

//Logs a completed assessment and creates an ad_hoc_assessment SOAR session.
export async function assessmentsApiCompleteWithSessionPost(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(
    jwt,
    `${api_url}/Assessment/complete/soar`,
    payload
  )
  if (res === null) {
    throw new Error(`Unable to submit a completed assessment`)
  }
  return res
}

export async function assessmentsApiSubmitSoarSessionPost(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(
    jwt,
    `${api_url}/Assessment/complete/soar/session`,
    payload
  )
  if (res === null) {
    throw new Error(`Unable to submit a completed assessment`)
  }
  return res
}

export async function assessmentsApiConfirmCompletePost(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(
    jwt,
    `${api_url}/Assessment/confirmCompleted`,
    payload
  )
  if (res === null) {
    throw new Error(`Unable to submit a completed assessment`)
  }
  return res
}

export async function assessmentsApiCompletedGet(jwt, assessmentId) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosGet(
    jwt,
    `${api_url}/Assessment/completed?id=${assessmentId}`
  )
  if (res === null) {
    throw new Error(`Unable to retrieve completed assessment`)
  }
  return res
}

export async function assessmentsApiCompletedGetWithStaged(
  jwt,
  assessmentId,
  completedAssessmentId
) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosGet(
    jwt,
    `${api_url}/Assessment/completed/${assessmentId}/${completedAssessmentId}`
  )
  if (res === null) {
    throw new Error(`Unable to retrieve completed assessment`)
  }
  return res
}

export async function assessmentsApiCompleteListPost(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(
    jwt,
    `${api_url}/Assessment/completed/list`,
    payload
  )
  if (res === null) {
    throw new Error(`Unable to submit a completed assessment listing request`)
  }
  return res
}

export async function assessmentsApiParticipantOverviewPost(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(jwt, `${api_url}/Participant/Overview`, payload)
  if (res === null) {
    throw new Error(`Unable to retrieve participant assessments overview`)
  }
  return res
}

export async function assessmentsApiParticipantOverviewSummaryPost(
  jwt,
  payload
) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(
    jwt,
    `${api_url}/Participant/Overview/summary`,
    payload
  )
  if (res === null) {
    throw new Error(
      `Unable to retrieve participant assessments overview summary`
    )
  }
  return res
}

export async function assessmentsApiSchedulePost(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(jwt, `${api_url}/Scheduling`, payload)
  if (res === null) {
    throw new Error(`Unable to create assessment schedule`)
  }
  return res
}

export async function assessmentsApiScheduleListPost(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(jwt, `${api_url}/Scheduling/list`, payload)
  if (res === null) {
    throw new Error(`Unable to list assessment schedules`)
  }
  return res
}

export async function assessmentsApiScheduleGet(jwt, id) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosGet(jwt, `${api_url}/Scheduling/${id}`)
  if (res === null) {
    throw new Error(`Unable to retrieve schedule profile`)
  }
  return res
}

export async function assessmentsApiScheduleTaskGet(jwt, id) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosGet(jwt, `${api_url}/Scheduling/task/${id}`)
  if (res === null) {
    throw new Error(`Unable to retrieve schedule task profile`)
  }
  return res
}

export async function assessmentsApiScheduleTaskCompletePut(jwt, id, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPut(
    jwt,
    `${api_url}/Scheduling/task/${id}/complete/soar`,
    payload
  )
  if (res === null) {
    throw new Error(`Unable to complete scheduled task`)
  }
  return res
}

export async function assessmentsApiScheduleDeletePost(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(jwt, `${api_url}/Scheduling/delete`, payload)
  if (res === null) {
    throw new Error(`Unable to delete assessment schedules`)
  }
  return res
}

export async function assessmentsApiScheduleUpdatePut(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPut(jwt, `${api_url}/Scheduling`, payload)
  if (res === null) {
    throw new Error(`Unable to update assessment schedules`)
  }
  return res
}

export async function assessmentsApiSystemAssessmentPost(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(jwt, `${api_url}/Assessment/system`, payload)
  if (res === null) {
    throw new Error(`Unable to update system assessment status`)
  }
  return res
}

export async function assessmentsApiSharedAssessmentPost(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(jwt, `${api_url}/Assessment/shared`, payload)
  if (res === null) {
    throw new Error(`Unable to update shared assessment status`)
  }
  return res
}

export async function assessmentsApiCloneAssessmentPost(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(jwt, `${api_url}/Assessment/clone`, payload)
  if (res === null) {
    throw new Error(`Unable to clone assessment`)
  }
  return res
}

export async function assessmentsApiActiveOrganizationsGet(jwt, enterpriseId) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosGet(
    jwt,
    `${api_url}/organization/activeList/${enterpriseId}`
  )
  if (res === null) {
    throw new Error(`Unable to retrieve active organization listing`)
  }
  return res
}

export async function assessmentsApiOrganizationGet(jwt, organizationId) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosGet(jwt, `${api_url}/organization/${organizationId}`)
  if (res === null) {
    throw new Error(`Unable to retrieve organization profile`)
  }
  return res
}

export async function assessmentsApiCheckStatus(jwt, payload) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosPost(jwt, `${api_url}/Assessment/status`, payload)
  if (res === null) {
    throw new Error(`Unable to check assessment statuses`)
  }
  return res
}

export async function assessmentsApiGetUsers(
  jwt,
  enterprise_id,
  organization_id
) {
  const api_url = assessmentsApiUrl()
  const res = await AxiosGet(
    jwt,
    `${api_url}/Assessment/list/users/${enterprise_id}/${organization_id}`
  )
  if (res === null) {
    throw new Error(`Unable to retrieve assessment management users`)
  }
  return res
}
